module.exports = __webpack_public_path__ + "media/images/home/phone-d4c467f080b52a6019f9efade6fa1ffd.svg";